var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle */
// Utils
import { attachGeneratedObjectIdToObjectOrReturn } from './attachGeneratedObjectIdToObjectOrReturn';
import { attachGeneratedObjectIdToValueRecursivelyOrReturn } from './attachGeneratedObjectIdToValueRecursivelyOrReturn';
import { OBJECT_ID } from '../constants';
/**
 * @description Attaches unique generated identifiers to the given object and any nested objects if missing, if the given object and all nested objects already have identifiers, the given object is returned.
 *
 * @template T
 * @param {T} givenObject
 * @param {string | null} [pathRelativeToParentObject=null]
 *
 * @return T
 */
export var attachGeneratedObjectIdToObjectRecursivelyOrReturn = function (givenObject, pathRelativeToParentObject) {
    if (pathRelativeToParentObject === void 0) { pathRelativeToParentObject = null; }
    var currentPropertyValue;
    var objectWithAttachedIdentifier = attachGeneratedObjectIdToObjectOrReturn(givenObject, pathRelativeToParentObject);
    var hasObjectOrNestedObjectHadIdentifierAttached = objectWithAttachedIdentifier !== givenObject;
    if (!hasObjectOrNestedObjectHadIdentifierAttached) {
        // Object already has an identifier attached, then we need to initialise a new object for our potential result
        objectWithAttachedIdentifier = __assign({}, givenObject);
    }
    Object.keys(objectWithAttachedIdentifier)
        .forEach(function (propertyName) {
        if (propertyName === OBJECT_ID || typeof objectWithAttachedIdentifier[propertyName] !== 'object')
            return;
        currentPropertyValue = objectWithAttachedIdentifier[propertyName];
        objectWithAttachedIdentifier[propertyName] = attachGeneratedObjectIdToValueRecursivelyOrReturn(currentPropertyValue, objectWithAttachedIdentifier[OBJECT_ID] + "_" + propertyName);
        if (objectWithAttachedIdentifier[propertyName] !== currentPropertyValue) {
            hasObjectOrNestedObjectHadIdentifierAttached = true;
        }
    });
    return hasObjectOrNestedObjectHadIdentifierAttached ? objectWithAttachedIdentifier : givenObject;
};
//# sourceMappingURL=attachGeneratedObjectIdToObjectRecursivelyOrReturn.js.map